import React from "react";

export const DownloadIcon = ({
  width = 22,
  height = 22,
  color = "#20A8E0",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 14.333V18.7775C21 19.3668 20.7659 19.9321 20.3491 20.3488C19.9324 20.7655 19.3671 20.9997 18.7778 20.9997H3.22222C2.63285 20.9997 2.06762 20.7655 1.65087 20.3488C1.23413 19.9321 1 19.3668 1 18.7775V14.333"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.44531 8.77734L11.0009 14.3329L16.5564 8.77734"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 14.3333V1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReplaceIcon = ({ width = 24, height = 20, color = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4962 8.33309H23.6113C23.6852 8.33312 23.7576 8.35571 23.8199 8.39822C23.8822 8.44074 23.932 8.50141 23.9633 8.57314C23.9946 8.64486 24.0063 8.72468 23.9968 8.80323C23.9874 8.88178 23.9572 8.95582 23.9099 9.01667L20.8524 12.9515C20.8159 12.9984 20.7702 13.0361 20.7186 13.062C20.667 13.0879 20.6107 13.1013 20.5538 13.1013C20.4968 13.1013 20.4405 13.0879 20.3889 13.062C20.3373 13.0361 20.2916 12.9984 20.2552 12.9515L17.1976 9.01667C17.1503 8.95582 17.1202 8.88178 17.1107 8.80323C17.1013 8.72468 17.1129 8.64486 17.1442 8.57314C17.1755 8.50141 17.2253 8.44074 17.2876 8.39822C17.35 8.35571 17.4223 8.33312 17.4962 8.33309ZM0.388662 11.6676H6.50382C6.5777 11.6676 6.65004 11.645 6.71238 11.6025C6.77471 11.56 6.82446 11.4993 6.85579 11.4276C6.88712 11.3559 6.89874 11.2761 6.88929 11.1975C6.87984 11.119 6.84971 11.0449 6.80243 10.9841L3.74485 7.04928C3.70836 7.00237 3.6627 6.96463 3.6111 6.93874C3.5595 6.91284 3.50322 6.89941 3.44624 6.89941C3.38927 6.89941 3.33299 6.91284 3.28139 6.93874C3.22979 6.96463 3.18413 7.00237 3.14764 7.04928L0.0900578 10.9841C0.0427753 11.0449 0.0126447 11.119 0.00319433 11.1975C-0.00625603 11.2761 0.00536496 11.3559 0.0366966 11.4276C0.0680282 11.4993 0.117773 11.56 0.180107 11.6025C0.242441 11.645 0.314783 11.6676 0.388662 11.6676Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9992 1.6636C9.58545 1.6636 7.42679 2.84237 6.00065 4.69471C5.93696 4.7832 5.85734 4.85706 5.76649 4.91189C5.67565 4.96673 5.57545 5.00142 5.47185 5.01391C5.36825 5.02639 5.26337 5.01642 5.16344 4.98458C5.06351 4.95274 4.97057 4.89968 4.89015 4.82856C4.80973 4.75744 4.74347 4.66972 4.69531 4.57059C4.64715 4.47147 4.61807 4.36298 4.60981 4.25157C4.60154 4.14015 4.61426 4.0281 4.6472 3.92206C4.68014 3.81603 4.73264 3.71817 4.80156 3.63432C5.94029 2.15632 7.45104 1.06006 9.15413 0.47592C10.8572 -0.108221 12.681 -0.155655 14.4085 0.339259C16.136 0.834172 17.6946 1.85061 18.8988 3.26767C20.103 4.68473 20.9023 6.44278 21.2015 8.33272H19.6198C19.2613 6.44975 18.3069 4.75741 16.9182 3.54211C15.5295 2.32681 13.7918 1.66321 11.9992 1.6636ZM4.37854 11.6673C4.67296 13.2089 5.36822 14.6297 6.38398 15.7657C7.39973 16.9016 8.69455 17.7063 10.1188 18.0868C11.5431 18.4672 13.0387 18.408 14.4329 17.9158C15.8271 17.4236 17.063 16.5186 17.9977 15.3053C18.0614 15.2168 18.141 15.1429 18.2318 15.0881C18.3227 15.0333 18.4229 14.9986 18.5265 14.9861C18.6301 14.9736 18.735 14.9836 18.8349 15.0154C18.9348 15.0473 19.0278 15.1003 19.1082 15.1714C19.1886 15.2426 19.2549 15.3303 19.303 15.4294C19.3512 15.5285 19.3803 15.637 19.3885 15.7484C19.3968 15.8598 19.3841 15.9719 19.3511 16.0779C19.3182 16.184 19.2657 16.2818 19.1968 16.3657C18.058 17.8437 16.5473 18.9399 14.8442 19.5241C13.1411 20.1082 11.3174 20.1557 9.58984 19.6607C7.86233 19.1658 6.30377 18.1494 5.09953 16.7323C3.89529 15.3153 3.09605 13.5572 2.79688 11.6673H4.37854Z"
      fill={color}
    />
  </svg>
);

export const TrashIcon = ({ width = 20, height = 22, color = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5H3H19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10V16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10V16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadCloudIcon = ({
  width = 27,
  height = 22,
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 27 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6749 15.4433L13.23 10.998L8.78516 15.4433"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2305 10.998V20.9998"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5525 18.1002C23.6363 17.5093 24.4925 16.5743 24.9859 15.4427C25.4793 14.3111 25.5819 13.0474 25.2774 11.851C24.9729 10.6547 24.2787 9.59378 23.3044 8.8358C22.3301 8.07781 21.1311 7.66591 19.8966 7.6651H18.4965C18.1602 6.36403 17.5333 5.15614 16.6629 4.13225C15.7926 3.10836 14.7015 2.29511 13.4717 1.75363C12.2419 1.21216 10.9053 0.95655 9.56244 1.00603C8.21961 1.05551 6.90546 1.40879 5.7188 2.0393C4.53214 2.66982 3.50385 3.56116 2.71123 4.64633C1.9186 5.73149 1.38228 6.98224 1.14258 8.30453C0.902881 9.62683 0.966037 10.9863 1.3273 12.2806C1.68857 13.575 2.33854 14.7706 3.22836 15.7776"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6749 15.4433L13.23 10.998L8.78516 15.4433"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ImageUploadIcon = ({
  width = 32,
  height = 32,
  color = "#20A8E0",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9993 17.3333L15.9993 12L19.9993 18V16H25.3327V6.66667C25.3327 5.196 24.1367 4 22.666 4H5.33268C3.86202 4 2.66602 5.196 2.66602 6.66667V22.6667C2.66602 24.1373 3.86202 25.3333 5.33268 25.3333H15.9993V20H6.66602L10.666 14.6667L11.9993 17.3333Z"
      fill={color}
    />
    <path
      d="M25.3327 18.667H22.666V22.667H18.666V25.3337H22.666V29.3337H25.3327V25.3337H29.3327V22.667H25.3327V18.667Z"
      fill={color}
    />
  </svg>
);

export const StarIcon = ({ width = 14, height = 16, color = "#EE3B2B" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92773 0L8.4556 5.35366L13.8559 4L9.98346 8L13.8559 12L8.4556 10.6463L6.92773 16L5.39987 10.6463L-0.000468731 12L3.87201 8L-0.000468731 4L5.39987 5.35366L6.92773 0Z"
      fill={color}
    />
  </svg>
);

export const getOriginStopIcon = () => {
  const svg = `
   <svg width="67" height="75" viewBox="0 0 67 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.7744 0C49.8593 0 57.4016 0.000262456 62.0879 4.68652C66.7742 9.37282 66.7744 16.9151 66.7744 32V34.7979C66.7744 49.8828 66.7741 57.425 62.0879 62.1113C58.3798 65.8194 52.8836 66.5904 43.2773 66.752C43.0885 66.7805 42.8631 66.7978 42.5977 66.7979C36.4493 66.7979 33.9789 74.8073 33.9629 74.8594C33.9594 74.8047 33.4412 66.7982 25.3281 66.7979C25.0518 66.7978 24.8037 66.7875 24.582 66.7695C14.3006 66.6458 8.53203 65.9568 4.68652 62.1113C0.00031205 57.425 0 49.8827 0 34.7979V32C0 16.9151 0.000233207 9.37281 4.68652 4.68652C9.37282 0.000231985 16.9151 0 32 0H34.7744Z" fill="#20A8E0"/>
<g clip-path="url(#clip0_11643_44400)">
<path d="M48.3542 34.5507C48.3542 46.6435 32.8119 57.0087 32.8119 57.0087C32.8119 57.0087 17.2695 46.6435 17.2695 34.5507C17.2695 30.4272 18.907 26.4726 21.8218 23.5568C24.7365 20.641 28.6898 19.0029 32.8119 19.0029C36.934 19.0029 40.8872 20.641 43.802 23.5568C46.7167 26.4726 48.3542 30.4272 48.3542 34.5507Z" stroke="#E9E9E9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M32.8116 39.7334C35.6729 39.7334 37.9924 37.413 37.9924 34.5508C37.9924 31.6885 35.6729 29.3682 32.8116 29.3682C29.9504 29.3682 27.6309 31.6885 27.6309 34.5508C27.6309 37.413 29.9504 39.7334 32.8116 39.7334Z" stroke="#E9E9E9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_11643_44400">
<rect width="41.4462" height="41.4608" fill="white" transform="translate(12.6641 17.2754)"/>
</clipPath>
</defs>
</svg>`.trim();
  const encodedSVG = encodeURIComponent(svg);
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(40, 45),
    anchor: new window.google.maps.Point(20, 45),
  };
};

export const getDestinationStopIcon = () => {
  const svg = `
    <svg width="67" height="75" viewBox="0 0 67 75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M34.7744 0C49.8593 0 57.4016 0.000262456 62.0879 4.68652C66.7742 9.37282 66.7744 16.9151 66.7744 32V34.7979C66.7744 49.8828 66.7741 57.425 62.0879 62.1113C58.3798 65.8194 52.8836 66.5904 43.2773 66.752C43.0885 66.7805 42.8631 66.7978 42.5977 66.7979C36.4493 66.7979 33.9789 74.8073 33.9629 74.8594C33.9594 74.8047 33.4412 66.7982 25.3281 66.7979C25.0518 66.7978 24.8037 66.7875 24.582 66.7695C14.3006 66.6458 8.53203 65.9568 4.68652 62.1113C0.00031205 57.425 0 49.8827 0 34.7979V32C0 16.9151 0.000233207 9.37281 4.68652 4.68652C9.37282 0.000231985 16.9151 0 32 0H34.7744Z" fill="#EE3B2B"/>
      <g clip-path="url(#clip0_11643_44390)">
        <path d="M48.3542 34.5507C48.3542 46.6435 32.8119 57.0087 32.8119 57.0087C32.8119 57.0087 17.2695 46.6435 17.2695 34.5507C17.2695 30.4272 18.907 26.4726 21.8218 23.5568C24.7365 20.641 28.6898 19.0029 32.8119 19.0029C36.934 19.0029 40.8872 20.641 43.802 23.5568C46.7167 26.4726 48.3542 30.4272 48.3542 34.5507Z" stroke="#E9E9E9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M32.8116 39.7334C35.6729 39.7334 37.9924 37.413 37.9924 34.5508C37.9924 31.6885 35.6729 29.3682 32.8116 29.3682C29.9504 29.3682 27.6309 31.6885 27.6309 34.5508C27.6309 37.413 29.9504 39.7334 32.8116 39.7334Z" stroke="#E9E9E9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_11643_44390">
          <rect width="41.4462" height="41.4608" fill="white" transform="translate(12.6641 17.2754)"/>
        </clipPath>
      </defs>
    </svg>`.trim();

  const encodedSVG = encodeURIComponent(svg);
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(40, 45),
    anchor: new window.google.maps.Point(20, 45),
  };
};

export const getIntermediateStopIcon = () => {
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#4CAF50" stroke="#FFFFFF" stroke-width="2"/>
      </svg>
    `)}`,
    scaledSize: new window.google.maps.Size(24, 24),
    anchor: new window.google.maps.Point(12, 12),
  };
};

export const getDriverIconSVG = () => {
  const svg = `
  <svg
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3234 19.3624L14.1707 12.9833C13.8703 12.5211 13.3578 12.3136 12.8442 12.3136C12.7379 12.3136 12.5179 12.3162 12.2801 12.3195C12.2616 12.2884 12.2423 12.2575 12.211 12.2364L11.165 11.5418C11.0443 11.4617 10.8876 11.4659 10.7719 11.5511L9.90685 12.1895L9.04122 11.5511C8.92458 11.4659 8.7688 11.4617 8.64717 11.5418L7.60309 12.2364C7.57359 12.2557 7.55485 12.2827 7.53765 12.311C7.29122 12.3126 7.06158 12.3139 6.96485 12.3139C6.45361 12.3139 5.94344 12.5242 5.64494 12.9833L1.4921 19.3624C1.05058 20.0396 1.22928 20.9452 1.89514 21.4038L2.81697 22.0392C3.37267 20.7159 4.29047 19.5843 5.44311 18.7582L5.68082 18.3926V18.5897C6.51608 18.0379 7.4643 17.6466 8.4823 17.4548C8.17982 16.7835 7.92598 15.9838 7.73983 15.23C7.52295 14.3504 7.39575 13.5353 7.39575 13.0737C7.39575 12.9026 7.41785 12.7378 7.45139 12.5772L8.20682 15.077C8.24592 15.2079 8.35913 15.3025 8.49475 15.3185C8.50843 15.32 8.52176 15.3208 8.53477 15.3208C8.65549 15.3208 8.76967 15.257 8.83174 15.1503L9.42067 14.1359L9.58635 14.3011C9.18985 14.8256 9.03407 16.3019 8.97359 17.3797C9.27954 17.3422 9.58947 17.3173 9.90532 17.3173C10.2218 17.3173 10.5327 17.3427 10.8396 17.3801C10.7791 16.3024 10.6233 14.826 10.2259 14.3011L10.3916 14.1349L10.9823 15.1503C11.0444 15.257 11.157 15.3208 11.2786 15.3208C11.2916 15.3208 11.3053 15.3199 11.3184 15.3184C11.4539 15.3024 11.5672 15.2078 11.6072 15.077L12.3622 12.5824C12.3946 12.7414 12.4159 12.9046 12.4159 13.0736C12.4159 13.9315 11.9858 16.0006 11.3299 17.4547C12.3498 17.6471 13.2995 18.0393 14.1348 18.5925V18.3935L14.3765 18.7639C15.5252 19.5905 16.4405 20.7201 16.9946 22.0412L17.9205 21.4038C18.5862 20.9452 18.764 20.0396 18.3234 19.3624ZM8.63502 14.1232L8.19539 12.6669L8.8277 12.2463L9.45665 12.7102L8.63502 14.1232ZM11.178 14.1232L10.3573 12.7102L10.9856 12.2463L11.6186 12.6669L11.178 14.1232Z"
      fill="#183059"
    />
    <path
      d="M7.75391 21.679L8.50449 22.6666C8.92054 22.4158 9.40274 22.2784 9.90444 22.2784C10.4071 22.2784 10.8902 22.4158 11.3063 22.6671L12.0569 21.6787C11.4717 21.1275 10.7121 20.8252 9.90541 20.8252C9.09832 20.8252 8.33783 21.1279 7.75391 21.679Z"
      fill="#183059"
    />
    <path
      d="M6.42578 8.1958C6.45125 9.49517 7.18938 10.6084 8.26485 11.1865C8.75598 11.4509 9.30985 11.6144 9.9071 11.6144C10.5034 11.6144 11.0557 11.4512 11.5463 11.1873C12.6214 10.61 13.3623 9.4969 13.3869 8.19708C12.4998 8.81343 11.2484 9.21402 9.9071 9.21402C8.5658 9.21402 7.31408 8.81343 6.42578 8.1958Z"
      fill="#183059"
    />
    <path
      d="M6.3287 5.1111L6.31722 6.14243C6.31911 6.95867 7.92629 8.02186 9.9096 8.02186C11.8929 8.02186 13.4986 6.95867 13.4995 6.14243L13.4889 5.11161C14.0108 4.97573 14.4158 4.77385 14.6751 4.48372C14.8783 4.25739 14.995 3.97829 14.995 3.62706C14.9951 2.03577 12.7161 0 9.90965 0C7.10072 0 4.82422 2.03577 4.82422 3.62706C4.82422 3.97829 4.94024 4.25693 5.14252 4.48372C5.40197 4.7738 5.80745 4.97568 6.3287 5.1111Z"
      fill="#183059"
    />
    <path
      d="M9.90643 18.2178C6.1673 18.2178 3.125 21.2602 3.125 24.9994H4.8334C4.8334 24.997 4.8334 24.9936 4.8334 24.9912V24.9896C4.88893 24.6549 5.17595 24.4111 5.51293 24.4111C5.5188 24.4111 5.52533 24.4116 5.53182 24.4116L8.17108 24.4801C8.12142 24.6458 8.08696 24.8179 8.08696 24.9995H11.7274C11.7274 24.8179 11.6933 24.6458 11.6427 24.4801L14.2828 24.4116C14.2884 24.4116 14.294 24.4111 14.3009 24.4111C14.6375 24.4111 14.9258 24.6549 14.9809 24.9896V24.9912C14.9809 24.9936 14.9809 24.997 14.9809 24.9994H16.6878C16.6879 21.2602 13.6465 18.2178 9.90643 18.2178ZM12.8339 22.1474L11.427 24.0011C11.1009 23.5067 10.5427 23.1791 9.90638 23.1791C9.27156 23.1791 8.71275 23.5064 8.38725 24.0008L6.98077 22.1479C6.74092 21.8318 6.77098 21.3862 7.05182 21.1054C7.84053 20.3171 8.87348 19.9229 9.9073 19.9229C10.9409 19.9229 11.9737 20.3171 12.7637 21.1061C13.0442 21.3867 13.0738 21.8314 12.8339 22.1474Z"
      fill="#20A8E0"
    />
  </svg>  `.trim();
  const encodedSVG = encodeURIComponent(svg);
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(20, 25),
    anchor: new window.google.maps.Point(10, 25),
  };
};

export const getAttendantIconSVG = () => {
  const svg = `
  <svg
    width="20"
    height="30"
    viewBox="0 0 20 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11703_14552)">
      <path
        d="M11.9818 0.123942C11.7799 0.228109 11.4609 0.592692 11.4609 0.71639C11.4609 0.742432 11.5521 0.781494 11.6628 0.807536C11.9688 0.86613 12.8867 1.31535 13.3555 1.63436C13.9023 1.99894 14.6185 2.7216 14.9896 3.27498L15.2826 3.71118L15.4062 3.43774C15.6927 2.79321 15.4974 1.86222 14.944 1.25024C14.6706 0.944255 14.0716 0.618734 13.6615 0.55363C13.4922 0.521078 13.2904 0.429932 13.1602 0.312744C12.776 -0.0257974 12.3789 -0.0909016 11.9818 0.123942Z"
        fill="#183059"
      />
      <path
        d="M8.30339 1.13314C6.44141 1.49772 4.95052 2.65658 4.13021 4.38184C3.90234 4.87012 3.64844 5.74902 3.64844 6.06803C3.64844 6.22428 3.67448 6.25033 3.81771 6.25033C4.11719 6.25033 4.5013 6.40007 4.70964 6.59538L4.91797 6.78418L5.64714 6.75814C6.32422 6.7321 6.40234 6.71257 6.86458 6.49121C7.39844 6.22428 7.74349 5.88574 8.08203 5.28678C8.66797 4.23861 9.78776 3.60059 10.9141 3.65918L11.2917 3.67871L11.5326 4.10189C12.0404 5.00684 13.0169 5.82715 13.9219 6.12012C14.1628 6.19824 14.4036 6.31543 14.4557 6.37402C14.5469 6.47819 14.5664 6.47819 14.8138 6.36751C14.957 6.30892 15.1719 6.25033 15.2891 6.25033C15.4714 6.25033 15.4974 6.23079 15.4974 6.06803C15.4974 5.74902 15.2435 4.87012 15.0156 4.38184C14.2734 2.81283 12.9258 1.68001 11.2982 1.23731C10.6276 1.05501 9 0.99642 8.30339 1.13314Z"
        fill="#183059"
      />
      <path
        d="M15.6928 1.413C15.9597 1.8492 16.1094 2.4742 16.0574 2.94946C16.0183 3.35311 15.8295 3.8479 15.6407 4.05623C15.543 4.16691 15.543 4.19946 15.6733 4.57707C15.8686 5.12394 15.9402 5.41691 16.0183 5.97681C16.0704 6.34139 16.129 6.51066 16.2722 6.69295C16.5261 7.01847 16.6303 7.37004 16.5847 7.7867C16.4871 8.71769 15.7644 9.56405 14.8594 9.79191L14.5535 9.87004L14.5144 10.6838C14.4884 11.1982 14.4233 11.6799 14.3321 12.0055C14.1693 12.5914 14.1628 12.5719 14.6837 12.7281C15.2826 12.9039 15.9141 13.0211 16.5717 13.0667L17.2162 13.1057L17.0144 12.8518C16.4219 12.0966 16.2136 11.1461 16.4415 10.2672C16.5782 9.74634 16.7084 9.51196 17.3139 8.70467C18.1928 7.5328 18.5899 6.53019 18.668 5.26717C18.7331 4.24504 18.4402 3.28149 17.8282 2.48722C17.3594 1.88175 16.448 1.30233 15.7058 1.13957L15.4975 1.09399L15.6928 1.413Z"
        fill="#183059"
      />
      <path
        d="M10.1602 4.25814C9.4375 4.45345 8.92969 4.8571 8.51953 5.55371C7.84245 6.71908 6.87891 7.29199 5.61589 7.29199H5.14062L5.16016 9.38835C5.1862 11.4652 5.1862 11.4977 5.36198 12.012C5.59635 12.7217 5.94141 13.2816 6.45573 13.7959C6.97005 14.3102 7.53646 14.6553 8.23958 14.8896C8.6888 15.0394 8.86458 15.0654 9.57422 15.0654C10.2839 15.0654 10.4596 15.0394 10.9089 14.8896C11.612 14.6553 12.1784 14.3102 12.6927 13.7959C13.207 13.2816 13.5521 12.7217 13.7865 12.012L13.9622 11.4912L13.9883 9.11491L14.0078 6.7321L13.5651 6.5498C12.5495 6.13314 11.5729 5.28678 11.1042 4.40788C10.987 4.18652 10.9544 4.16699 10.7135 4.1735C10.5703 4.1735 10.3229 4.21257 10.1602 4.25814ZM8.23958 7.56543C8.72786 7.81283 8.90365 8.06673 8.71484 8.25553C8.59766 8.37272 8.48047 8.35319 8.2526 8.17741C8.13542 8.09277 7.92057 7.98861 7.77083 7.94954C7.43229 7.8584 7.04167 7.94303 6.72917 8.17741C6.5013 8.35319 6.38411 8.37272 6.26693 8.25553C6.08464 8.07324 6.2474 7.81934 6.70964 7.57845C7.19141 7.33757 7.75781 7.33105 8.23958 7.56543ZM12.4062 7.56543C12.8945 7.81283 13.0703 8.06673 12.8815 8.25553C12.7643 8.37272 12.6471 8.35319 12.4193 8.17741C12.3021 8.09277 12.0872 7.98861 11.9375 7.94954C11.599 7.8584 11.2083 7.94303 10.8958 8.17741C10.668 8.35319 10.5508 8.37272 10.4336 8.25553C10.2513 8.07324 10.4141 7.81934 10.8763 7.57845C11.3581 7.33757 11.9245 7.33105 12.4062 7.56543ZM7.84896 8.75684C7.95312 8.85449 8.01172 8.99121 8.01172 9.11491C8.01172 9.23861 7.95312 9.37533 7.84896 9.47298C7.7513 9.57715 7.61458 9.63574 7.49089 9.63574C7.36719 9.63574 7.23047 9.57715 7.13281 9.47298C7.02865 9.37533 6.97005 9.23861 6.97005 9.11491C6.97005 8.99121 7.02865 8.85449 7.13281 8.75684C7.23047 8.65267 7.36719 8.59408 7.49089 8.59408C7.61458 8.59408 7.7513 8.65267 7.84896 8.75684ZM12.0156 8.75684C12.1198 8.85449 12.1784 8.99121 12.1784 9.11491C12.1784 9.23861 12.1198 9.37533 12.0156 9.47298C11.918 9.57715 11.7812 9.63574 11.6576 9.63574C11.5339 9.63574 11.3971 9.57715 11.2995 9.47298C11.1953 9.37533 11.1367 9.23861 11.1367 9.11491C11.1367 8.99121 11.1953 8.85449 11.2995 8.75684C11.3971 8.65267 11.5339 8.59408 11.6576 8.59408C11.7812 8.59408 11.918 8.65267 12.0156 8.75684ZM9.79557 9.47949C9.85417 9.53158 9.89974 9.59668 9.89974 9.61621C9.89974 9.64225 9.78255 9.87663 9.63281 10.1436L9.36589 10.6253L9.60026 10.8662C9.73047 10.9964 9.83464 11.1527 9.83464 11.2048C9.83464 11.3285 9.70443 11.4587 9.58073 11.4587C9.45703 11.4587 8.79297 10.8076 8.79297 10.6904C8.79297 10.5798 9.28125 9.66178 9.43099 9.486C9.55469 9.34928 9.66536 9.34277 9.79557 9.47949ZM8.47396 12.7087C8.86458 12.9105 8.92969 12.9235 9.57422 12.9235C10.2253 12.9235 10.2773 12.9105 10.7005 12.7021C11.1758 12.4613 11.3451 12.4743 11.3841 12.7412C11.4102 12.904 11.1758 13.0798 10.6745 13.2946C10.3815 13.4183 10.2057 13.4378 9.57422 13.4378C8.94271 13.4378 8.76693 13.4183 8.47396 13.2946C7.82943 13.0212 7.62109 12.7868 7.82943 12.5785C7.94661 12.4613 8.01172 12.4808 8.47396 12.7087Z"
        fill="#183059"
      />
      <path
        d="M3.58463 6.81657C3.3763 6.89469 3.1289 7.19417 3.08984 7.40902C2.95312 8.14469 3.55208 9.04313 4.33333 9.28402L4.63281 9.36865L4.61328 8.30094L4.59374 7.22673L4.39192 7.0249C4.1901 6.82959 3.80598 6.72542 3.58463 6.81657Z"
        fill="#183059"
      />
      <path
        d="M15.0104 6.82959C14.9388 6.86214 14.8086 6.96631 14.7174 7.06397C14.5612 7.23324 14.5547 7.2723 14.5352 8.30745L14.5156 9.36865L14.8151 9.28402C14.9779 9.23193 15.1667 9.15381 15.2253 9.10824C15.7852 8.68506 16.0456 8.22282 16.0456 7.63688C16.0521 7.26579 16.0326 7.2137 15.8503 7.0249C15.6354 6.81006 15.2513 6.72542 15.0104 6.82959Z"
        fill="#183059"
      />
      <path
        d="M7.2296 15.4233C7.2296 16.2502 6.76736 16.9207 6.04471 17.1486C5.68664 17.2593 5.67361 17.2723 5.75174 17.4155C6.31815 18.4637 9.54731 24.1538 9.57335 24.1538C9.5994 24.1538 11.9562 20.0002 13.2322 17.702L13.4796 17.2658L13.102 17.1486C12.3793 16.9207 11.9171 16.2502 11.9171 15.4233V15.0457L11.5655 15.202C10.9145 15.4884 10.4392 15.5861 9.60591 15.5861C8.76606 15.5926 8.38846 15.521 7.67231 15.2345L7.2296 15.0522V15.4233Z"
        fill="#183059"
      />
      <path
        d="M3.89583 17.1943C3.45312 17.4156 3.25781 17.5523 3.25781 17.6305C3.25781 17.689 3.375 18.0015 3.51172 18.3271C4.04557 19.564 4.25391 20.5927 4.25391 21.9403C4.2474 22.995 4.11719 23.7698 3.77865 24.7659L3.58333 25.3518V27.5198V29.6877H9.57292H15.5625V27.5198V25.3518L15.3672 24.7659C15.0221 23.7633 14.8984 22.995 14.8919 21.9403C14.8854 20.5536 15.1198 19.4403 15.6667 18.2424C15.7904 17.9755 15.888 17.7021 15.888 17.637C15.888 17.5458 15.7122 17.4286 15.237 17.1877C14.8789 17.012 14.5273 16.8622 14.4557 16.8622C14.3841 16.8622 14.2865 16.9273 14.2344 17.0055C14.1823 17.0901 13.1602 18.9 11.9557 21.0289C10.7578 23.1578 9.72917 24.9286 9.67708 24.9677C9.60547 25.0133 9.54036 25.0133 9.46875 24.9677C9.41667 24.9286 8.38802 23.1578 7.1901 21.0289C5.99219 18.9 4.96354 17.0901 4.91146 17.0055C4.77474 16.7971 4.60547 16.8297 3.89583 17.1943Z"
        fill="#183059"
      />
      <path
        d="M2.4375 18.7633C2.19661 18.9911 1.88411 19.3167 1.7474 19.4859L1.5 19.8049V24.7463V29.6877H2.28125H3.0625V27.4482V25.2086L3.23177 24.7659C3.79818 23.2489 3.89583 21.4911 3.49219 19.9091C3.32292 19.245 2.9974 18.3596 2.91927 18.3596C2.89323 18.3596 2.67839 18.5419 2.4375 18.7633Z"
        fill="#183059"
      />
      <path
        d="M15.9987 18.8219C15.2369 20.7685 15.2109 22.8909 15.914 24.7659L16.0833 25.2086V27.4482V29.6877H17.3854H18.6875V26.2763C18.6875 22.5784 18.6614 22.1812 18.3554 21.2568C18.0494 20.3388 17.7044 19.7854 16.9557 19.0237C16.5976 18.6591 16.2721 18.3596 16.2396 18.3596C16.207 18.3596 16.0963 18.568 15.9987 18.8219Z"
        fill="#183059"
      />
    </g>
    <defs>
      <clipPath id="clip0_11703_14552">
        <rect width="20" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>`.trim();

  const encodedSVG = encodeURIComponent(svg);
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(20, 30),
    anchor: new window.google.maps.Point(10, 30),
  };
};

export const getPhoneIconSVG = () => {
  const svg = `<svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        width="32"
                                        height="32"
                                        rx="16"
                                        fill="#008C23"
                                      />
                                      <path
                                        d="M21.3335 15.3326H22.6668C22.6668 11.9126 20.0848 9.33325 16.6602 9.33325V10.6666C19.3682 10.6666 21.3335 12.6286 21.3335 15.3326Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M16.6669 13.3333C18.0689 13.3333 18.6669 13.9313 18.6669 15.3333H20.0002C20.0002 13.1833 18.8169 12 16.6669 12V13.3333ZM18.9482 16.962C18.8201 16.8456 18.6518 16.7835 18.4787 16.7888C18.3057 16.7942 18.1415 16.8665 18.0209 16.9907L16.4255 18.6313C16.0415 18.558 15.2695 18.3173 14.4749 17.5247C13.6802 16.7293 13.4395 15.9553 13.3682 15.574L15.0075 13.978C15.1318 13.8574 15.2043 13.6932 15.2096 13.5201C15.215 13.3471 15.1528 13.1787 15.0362 13.0507L12.5729 10.342C12.4562 10.2136 12.2941 10.1357 12.121 10.1248C11.9478 10.114 11.7773 10.1711 11.6455 10.284L10.1989 11.5247C10.0836 11.6403 10.0148 11.7943 10.0055 11.9573C9.99552 12.124 9.80485 16.072 12.8662 19.1347C15.5369 21.8047 18.8822 22 19.8035 22C19.9382 22 20.0209 21.996 20.0429 21.9947C20.2059 21.9855 20.3597 21.9164 20.4749 21.8007L21.7149 20.3533C21.8278 20.2217 21.885 20.0512 21.8743 19.878C21.8636 19.7049 21.7859 19.5427 21.6575 19.426L18.9482 16.962Z"
                                        fill="white"
                                      />
                                    </svg>  `.trim();
  const encodedSVG = encodeURIComponent(svg);
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(32, 32),
    anchor: new window.google.maps.Point(16, 32),
  };
};
